var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.835,
    height: 11,
    viewBox: "0 0 12.835 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23838",
    "data-name": "Path 23838",
    d: "M20.745,14.535A.913.913,0,0,0,19.907,14H8.92a.913.913,0,0,0-.839.535.9.9,0,0,0,.136.975h0l4.362,5.075v3.955a.458.458,0,0,0,.713.381l2.75-1.833a.458.458,0,0,0,.2-.381V20.587l4.363-5.076A.9.9,0,0,0,20.745,14.535Zm-5.3,5.583a.459.459,0,0,0-.111.3v2.046L13.5,23.685V20.417a.459.459,0,0,0-.111-.3l-4.469-5.2h11Z",
    transform: "translate(-7.996 -14)",
    fill: "#e10092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.9ed65bb405ca434dfdf3749babc35d70.svg";
export { ForwardRef as ReactComponent };